// Environment-based API URL configuration
const getServiceApiUrl = () => {
  // Use REACT_APP_ENV if set (for staging/testing builds), otherwise fall back to NODE_ENV
  // Note: NODE_ENV is always "production" in production builds, so we need a custom env var
  const env =
    process.env.REACT_APP_ENV || process.env.NODE_ENV || "development";

  // Use environment to determine which environment variable to use
  switch (env) {
    case "production":
      return process.env.REACT_APP_API_BASE_URL_PRODUCTION;
    case "staging":
      return process.env.REACT_APP_API_BASE_URL_STAGING;
    case "testing":
      return process.env.REACT_APP_API_BASE_URL_TESTING;
    case "development":
    default:
      return process.env.REACT_APP_API_BASE_URL_LOCAL;
  }
};

const service_api = getServiceApiUrl();

// Socket API URL - typically same as service API but for WebSocket connections
const socket_api = getServiceApiUrl();

const logo_url = "https://panichef.s3.us-east-2.amazonaws.com/logo.png";

export { logo_url, service_api, socket_api };
